var App = App || {};

App.EventTimezone = (function ($) {
    "use strict";

    function init() {
        var details = $(".block.block-event-details")
        if (details.length) {
            details.each(function () {
                SetTimezone($(this))
            });
        }

        var seriesItems = $(".block.block-event-series-details .events-list-item")
        if (seriesItems.length) {
            seriesItems.each(function () {
                SetTimezone($(this))
            });
        }

        var registrationItem = $(".offcanvas.offcanvas-end.offcanvas-registration")
        if (registrationItem.length) {
            registrationItem.each(function () {
                SetTimezone($(this))
            });
        }

        var pastEvents = $(".block.block-past-events-for-purchase .events-list-item-date")
        if (pastEvents.length) {
            pastEvents.each(function () {
                SetTimezone($(this))
            });
        }
    }
    function SetTimezone($section) {
        // TODO: There is no time zone data inherent in a DateTime value. It's unlikely this works as intended.
        // On the topic of an audience spanning multiple time zones, DateTime ought be stored as DateTimeUtc or DateTimeOffset
        // At which point times can be displayed relative to either presenter (US East Coast) or local time (if available)
        var $end = $section.find(".end-date-js");
        var $timeZoneDisplay = $section.find(".time-zone");

        //var timeZone = new Date(end.text()).toLocaleString('en-US', { timeZoneName: 'short' }).split(' ').pop();
        var timeZone = easternIsoTimeZone($end.text());
        $timeZoneDisplay.text(timeZone)
    }

    function easternIsoTimeZone(dateLiteral) {
        var date = new Date(dateLiteral);
        if (isNaN(date.getTime())) {
            return "";
        }
        var parts = new Intl.DateTimeFormat("en-US", {
            timeZone: "America/New_York",
            timeZoneName: "short"
        }).formatToParts(date);

        var timeZone = (parts.find(p => p.type === "timeZoneName") || {}).value || "";
        return timeZone;
    }

    return {
        init: init,
        easternIsoTimeZone: easternIsoTimeZone
    };

})(jQuery);

$(function () {
    App.EventTimezone.init();
});